import React, { useState, useEffect } from "react";
import {
  Table,
  Tooltip,
  Select,
  Form,
  notification,
  Row,
  Card,
  Alert,
  Tag,
} from "antd";
import { getListFormateursByUser } from "../../../../../api/geoprod";
import { useTranslation } from "react-i18next";
import classes from "../../../../Etablissements/Etablissements.module.css";

const { Option } = Select;


const getProfilByModule = (Module,liste_profils) => {
  const found = liste_profils?.find((p) => p?.Module === Module);
  return {
    competences: found?.compétances || [],
    diplomes: found?.Diplômes || [],
  };
};
const getModuleLabelByCode = (codeModule, modulesFormation) => {
  return (
    modulesFormation[0]?.items?.find((mod) => mod?.code_module === codeModule)
      ?.intitulé?.[0] 
  );
};

function parseData(planning,modulesFormation,liste_profils) {
  
  const result = [];
  planning?.forEach((semestreObj, semestreIndex) => {
    const semestreKey = Object.keys(semestreObj)[0];
    const modules = semestreObj[semestreKey];
    const semestreNumber = semestreIndex + 1;

    Object.entries(modules).forEach(([Module, heures], moduleIndex) => {
      // debugger
      const totalHeures = heures.reduce((acc, h) => acc + h, 0);

      if (totalHeures <= 0) return; // 👈 Ignore ce module
      const Semaines = heures
        .map((h, index) => (h > 0 ? `S${index + 1}` : null))
        .filter(Boolean);
      // const totalHeures = heures.reduce((acc, h) => acc + h, 0);
      // debugger
      const label = getModuleLabelByCode(Module, modulesFormation);

      const profil = getProfilByModule(label,liste_profils);
      // debugger
      
      const key = `${semestreNumber}-${moduleIndex}`;
      result.push({
        key: key,
        Semestre: `Semestre ${semestreNumber}`,
        moduleId: `${Module} (${totalHeures}h)`,
        Module,
        moduleLabel: label,
        Semaines: Semaines.join(", "),
        competences: profil.competences,
        diplomes: profil.diplomes,
      });
    });
  });
  return result;
}

const EtapeAffectationModule = ({ globalData, recap,setGlobalData,id_session_formation_homologuee,setIsLoading }) => {
  const { t, i18n } = useTranslation();

  const [formateurs, setFormateurs] = useState([]);
  const [tableData, setTableData] = useState(JSON.parse(sessionStorage.getItem("globalData"))?.affectationModules ? JSON.parse(sessionStorage.getItem("globalData"))?.affectationModules : parseData(globalData?.modules_planning,globalData?.modules_formation,globalData?.liste_profils_personnel))
  
  useEffect(() => {
    const fetchData = async () => {
      try {
         setIsLoading(true)
        const res = await getListFormateursByUser();
        setFormateurs(res?.data?.data[0] || []);
         setIsLoading(false)
      } catch (error) {
         setIsLoading(false)
        notification.error({
          message: t("Erreur"),
          description:
            error?.response?.data?.message ||
            "Erreur lors de la récupération des formateurs.",
          duration: 0,
        });
      }
    };
    // debugger
    if(!recap && sessionStorage.getItem("consulter") !== "true" )
    {
    fetchData();

    }
  }, []);


  const countBySemestre = {};
  tableData.forEach((item) => {
    countBySemestre[item.Semestre] = (countBySemestre[item.Semestre] || 0) + 1;
  });

  let indexTracker = {};
  const dataWithRowSpan = tableData.map((row) => {
    indexTracker[row.Semestre] = (indexTracker[row.Semestre] || 0) + 1;
    return {
      ...row,
      semestreRowSpan:
        indexTracker[row.Semestre] === 1 ? countBySemestre[row.Semestre] : 0,
    };
  });

  // const handleFormateurChange = (value, rowKey) => {
  //   const updated = tableData.map((row) =>
  //     row.key === rowKey ? { ...row, selectedFormateur: value } : row
  //   );
  //   setTableData(updated);
  // };
  const handleFormateurChange = (label, rowKey) => {
    
    const selected = formateurs.find((f) => `${f.nom} ${f.prenom}` === label);
    const id = selected?.id;
  
    const updated = tableData?.map((row) =>
      row.key === rowKey
        ? {
            ...row,
            nameFormateur: label,
            Formateur: id,
          }
        : row
    );
    setTableData(updated);
      const x = {
      // ...globalData,
        ...JSON.parse(sessionStorage.getItem("globalData")),
      affectationModules: updated,
    };

        sessionStorage.setItem("globalData", JSON.stringify(x));
        setGlobalData(x);
  }
  const columns = [
    {
      title: "Semestre",
      dataIndex: "Semestre",
      render: (text, row) => ({
        children: text,
        props: {
          rowSpan: row.semestreRowSpan,
        },
      }),
    },
    {
      title: "Module",
      dataIndex: "moduleId",
      render: (text, row) => (
    <Tooltip title={row.moduleLabel}>
      <span>{text}</span>
    </Tooltip>
  ),
      // render: (text, row) => <Tooltip title={row.Module}>{text}</Tooltip>,
    },
    {
      title: "Semaines",
      dataIndex: "Semaines",
    },
    {
      title: "Profil",
      dataIndex: "Module",
      render: (_, row) => (
        <div>
          <div>
            <span>Compétences : </span>
            {row?.competences?.map((comp, idx) => (
              <Tag color="blue" key={idx}>
                {comp}
              </Tag>
            ))}
          </div>
          <div style={{ marginTop: 10 }}>
            <span>Diplômes : </span>
            {row?.diplomes?.map((dip, idx) => (
              <Tag color="green" key={idx}>
                {dip}
              </Tag>
            ))}
          </div>
        </div>
      ),
    },
    {
      title: "Formateur",
      dataIndex: "key",
      render: (key) => (
        <Form.Item
          name={["formateurs", key]}
          rules={[
            { required: true, message: "Veuillez sélectionner un formateur" },
          ]}
        >
          <Select
            disabled={recap||id_session_formation_homologuee}
            showSearch
            placeholder="Choisir un formateur"
            style={{ width: "100%", height: "30px" }}
            size="small"
            onChange={(value) => handleFormateurChange(value, key)}
          >
            {formateurs.map((f) => {
              const label = `${f.nom} ${f.prenom}`;
              return (
                <Option key={label} value={label}>
                  {label}
                </Option>
          
              );
            })}
          </Select>
        </Form.Item>
      ),
    },
  ];


  return (
    <div style={{ width: "100%" }}>
      {!recap && (
        <Alert
          type="info"
          style={{ marginBlock: "1rem" }}
          message="Affectation des formateurs"
          description="Veuillez sélectionner un formateur pour chaque module."
          showIcon
        />
      )}
      <Row className={classes.listeRow}>
        <Card
          className={classes.listeCard}
          style={{ marginBottom: "40px" }}
          bordered={false}
          title={
            <div
              style={{
                textAlign: i18n?.dir() === "ltr" ? "left" : "right",
                fontSize: "18px",
                fontWeight: "600",
                color: "#195a99",
              }}
            >
              {t("Affectation des formateurs")}
            </div>
          }
        >
          <Table
            dataSource={dataWithRowSpan}
            columns={columns}
            pagination={false}
            bordered
            size="small"
            rowKey="key"
          />
        </Card>
      </Row>
    </div>
  );
};

export default EtapeAffectationModule;
